import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// LIBS
import API from "../../api";
import { fioFromObject } from "../../lib/helpers/strings";
import { getDateFormat } from "../../lib/helpers/dates";
import { getDocsType, getDocsNumberFormatted } from "../../lib/helpers/users";

// UI
import { TelPhones } from "@malond/ui-phone";
import {
  Alerts,
  P,
  Header,
  HeaderPage,
  Button,
  Box,
  Row,
  Col,
  HR
} from "../../ui";

class DepositorOnePage extends Component {
  state = {
    titleHeader: "Залогодатель",
    depositor: { role_id: {}, filial_id: {} }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;

    const depositor = await API.depositors.getOne(id);

    if (depositor && depositor._id) {
      let titleHeader = `${fioFromObject(depositor)} - ${
        this.state.titleHeader
      }`;
      this.setState({ depositor, titleHeader });
    } else {
      Alerts.error("Залогодатель не найден");
    }
  }

  render() {
    const { id } = this.props.match.params;
    const { depositor } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          preBeforeTitle={this.state.titleHeader}
          title={fioFromObject(depositor)}
          postSubTitle={getDocsNumberFormatted(depositor.ud_number)}
          back={this.props.history.goBack}
        />

        <Box>
          <Row withMain={true}>
            <Col padding="no" main={true}>
              <Header size={2} margin="no-top">
                Информация
              </Header>
            </Col>
            <Col padding="no" normal={true}>
              <Button
                size="s"
                type="as"
                as={Link}
                to={`/depositors/${id}/edit`}
              >
                Изменить информацию
              </Button>
            </Col>
          </Row>

          <Row>
            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Главное
              </Header>

              <Header size={6} margin="no-bottom">
                ФИО:
              </Header>
              <P slim>{fioFromObject(depositor)}</P>

              <Header size={6} margin="no-bottom">
                ИИН (при поиске):
              </Header>
              <P slim>{getDocsNumberFormatted(depositor.ud_number)}</P>

              <Header size={6} margin="no-bottom">
                ИИН (в документе):
              </Header>
              <P slim>{getDocsNumberFormatted(depositor.iin)}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Документ
              </Header>

              <Header size={6} margin="no-bottom">
                Вид документа:
              </Header>
              <P slim>{getDocsType(depositor.docs)}</P>

              <Header size={6} margin="no-bottom">
                Номер документа:
              </Header>
              <P slim>{getDocsNumberFormatted(depositor.docs_number)}</P>

              <Header size={6} margin="no-bottom">
                Кем выдан:
              </Header>
              <P slim>{depositor.docs_give_from || "Не указано"}</P>

              <Header size={6} margin="no-bottom">
                Дата выдачи:
              </Header>
              <P slim>{depositor.docs_give_date || "Не указана"}</P>

              <Header size={6} margin="no-bottom">
                Дата истечения:
              </Header>
              <P slim>{depositor.docs_expire_date || "Не указана"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Прочее
              </Header>

              <Header size={6} margin="no-bottom">
                Телефон:
              </Header>
              <P slim>
                <TelPhones sizeNormal={true}>{depositor.tel}</TelPhones>
              </P>

              <Header size={6} margin="no-bottom">
                Адрес проживания:
              </Header>
              <P slim>{depositor.place || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Адрес регистрации:
              </Header>
              <P slim>{depositor.place_registered || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Адрес рождения:
              </Header>
              <P slim>{depositor.place_birthday || "Не указан"}</P>

              <Header size={6} margin="no-bottom">
                Дата рождения:
              </Header>
              <P slim>{depositor.date_birthday || "Не указан"}</P>
            </Col>

            <Col padding="no-top-left">
              <Header size={5} margin="no-top">
                Изменения
              </Header>

              <Header size={6} margin="no-bottom">
                Дата создания:
              </Header>
              <P slim>{getDateFormat(depositor.created_at)}</P>

              <Header size={6} margin="no-bottom">
                Дата обновления:
              </Header>
              <P slim>{getDateFormat(depositor.updated_at)}</P>
            </Col>
          </Row>

          <HR mutted theme={"dashed"} />

          <Header size={4}>Операции с залогодателем</Header>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(withAuth(DepositorOnePage));
